/* HSK Where to Play v2: approved photographs, modal gallery, editor lifecycle. */
(function () {
  'use strict';
  if (window.HSKWhereToPlay) { window.HSKWhereToPlay.boot(document); return; }
  var instances = new WeakMap();
  function normalize(value) { return (value || '').toLowerCase().trim().replace(/\s+/g, '-'); }
  function init(root) {
    if (instances.has(root)) return;
    var dialog = root.querySelector('[data-hsk-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var cards = Array.from(dialog.querySelectorAll('[data-hsk-scene]'));
    var scenes = cards.map(function (card) {
      var image = card.querySelector('img');
      return { key: card.dataset.hskScene, title: card.dataset.title, copy: card.dataset.copy, link: card.dataset.link, image: image.getAttribute('src'), alt: image.alt, card: card };
    });
    if (!scenes.length) return;
    var abort = new AbortController();
    var options = { signal: abort.signal };
    var overview = dialog.querySelector('[data-hsk-overview]');
    var detail = dialog.querySelector('[data-hsk-detail]');
    var detailImage = dialog.querySelector('[data-hsk-detail-image]');
    var detailTitle = dialog.querySelector('[data-hsk-scene-title]');
    var detailCopy = dialog.querySelector('[data-hsk-scene-copy]');
    var detailShop = dialog.querySelector('[data-hsk-scene-shop]');
    var counter = dialog.querySelector('[data-hsk-count]');
    var closeButton = dialog.querySelector('[data-hsk-close]');
    var heroImage = root.querySelector('.hsk-hero-img');
    var subtitle = root.querySelector('.hsk-sub');
    var shop = root.querySelector('.hsk-btn--red');
    var tabs = Array.from(root.querySelectorAll('.hsk-place'));
    var index = 0, invoker = null, scrollState = null, imageRequest = 0;
    function lockScroll() {
      if (scrollState) return;
      scrollState = { html: document.documentElement.style.overflow, body: document.body.style.overflow };
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }
    function unlockScroll() {
      if (!scrollState) return;
      document.documentElement.style.overflow = scrollState.html;
      document.body.style.overflow = scrollState.body;
      scrollState = null;
    }
    function updateHero(scene) {
      tabs.forEach(function (tab) {
        var active = normalize(tab.dataset.place) === scene.key;
        tab.classList.toggle('active', active);
        tab.setAttribute('aria-pressed', String(active));
      });
      if (subtitle) subtitle.textContent = scene.copy;
      if (shop) shop.href = scene.link;
      if (!heroImage) return;
      var request = ++imageRequest;
      var preload = new Image();
      heroImage.classList.add('is-changing');
      preload.onload = function () {
        if (request !== imageRequest || !root.isConnected) return;
        heroImage.removeAttribute('srcset');
        heroImage.removeAttribute('sizes');
        heroImage.src = scene.image;
        heroImage.alt = scene.alt;
        heroImage.classList.remove('is-changing');
      };
      preload.onerror = function () { if (request === imageRequest) heroImage.classList.remove('is-changing'); };
      preload.src = scene.image;
    }
    function selectScene(key, moveFocus) {
      var nextIndex = scenes.findIndex(function (scene) { return scene.key === normalize(key); });
      if (nextIndex < 0) return;
      index = nextIndex;
      var scene = scenes[index];
      overview.hidden = true;
      detail.hidden = false;
      detailImage.src = scene.image;
      detailImage.alt = scene.alt;
      detailTitle.textContent = scene.title;
      detailCopy.textContent = scene.copy;
      detailShop.href = scene.link;
      detailShop.textContent = scene.key === 'pool' ? 'SHOP WATER SAUCE →' : scene.key === 'street-hockey' ? 'SHOP PUCKS & BALLS →' : 'SHOP SAUCE KITS →';
      counter.textContent = String(index + 1) + ' / ' + String(scenes.length) + ' · ' + scene.title;
      dialog.scrollTop = 0;
      updateHero(scene);
      if (moveFocus && dialog.open) detailTitle.focus({ preventScroll: true });
    }
    function showOverview(moveFocus) {
      overview.hidden = false;
      detail.hidden = true;
      dialog.scrollTop = 0;
      if (moveFocus && dialog.open) scenes[index].card.focus({ preventScroll: true });
    }
    function openGallery(trigger, key) {
      invoker = trigger;
      if (key) selectScene(key, false); else showOverview(false);
      if (!dialog.open) {
        lockScroll();
        try { dialog.showModal(); } catch (error) { unlockScroll(); return; }
      }
      dialog.scrollTop = 0;
      (key ? detailTitle : closeButton).focus({ preventScroll: true });
    }
    root.querySelectorAll('[data-hsk-open-gallery]').forEach(function (button) {
      button.addEventListener('click', function () { openGallery(button); }, options);
    });
    tabs.forEach(function (button) {
      button.addEventListener('click', function () { openGallery(button, normalize(button.dataset.place)); }, options);
    });
    cards.forEach(function (card) {
      card.addEventListener('click', function () { selectScene(card.dataset.hskScene, true); }, options);
    });
    closeButton.addEventListener('click', function () { dialog.close(); }, options);
    dialog.querySelector('[data-hsk-back]').addEventListener('click', function () { showOverview(true); }, options);
    dialog.querySelector('[data-hsk-prev]').addEventListener('click', function () { selectScene(scenes[(index + scenes.length - 1) % scenes.length].key, false); }, options);
    dialog.querySelector('[data-hsk-next]').addEventListener('click', function () { selectScene(scenes[(index + 1) % scenes.length].key, false); }, options);
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }, options);
    dialog.addEventListener('keydown', function (event) {
      if (detail.hidden || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        var step = event.key === 'ArrowRight' ? 1 : -1;
        selectScene(scenes[(index + step + scenes.length) % scenes.length].key, false);
      }
    }, options);
    // Native dialog handles Escape, inert background and keyboard focus containment.
    dialog.addEventListener('close', function () {
      unlockScroll();
      if (invoker && invoker.isConnected) invoker.focus({ preventScroll: true });
      invoker = null;
    }, options);
    instances.set(root, { destroy: function () {
      imageRequest++;
      invoker = null;
      if (dialog.open) dialog.close();
      unlockScroll();
      abort.abort();
      instances.delete(root);
    } });
    root.dataset.locationReady = 'gallery-v2';
  }
  function rootsWithin(scope) {
    var roots = Array.from(scope.querySelectorAll('[data-hsk-gallery]'));
    if (scope.matches && scope.matches('[data-hsk-gallery]')) roots.unshift(scope);
    return roots;
  }
  function boot(scope) { rootsWithin(scope || document).forEach(init); }
  window.HSKWhereToPlay = { boot: boot, version: '2.0.0' };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    rootsWithin(event.target).forEach(function (root) { var instance = instances.get(root); if (instance) instance.destroy(); });
  });
})();
